"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiRequest = void 0;
const axios_1 = __importDefault(require("axios"));
const jsencrypt_1 = require("jsencrypt");
const trade_utils_lib_1 = require("trade_utils_lib");
const bu_account_config_1 = require("./bu_account_config");
const client_1 = require("./secure-remote-password/client");
const { log } = bu_account_config_1.BUAccountConfig;
function apiRequest(host, path, initParam, privateData, sessionHandler, accessToken) {
    const url = `${host}/${path}`;
    let session_data = {};
    let sessionHandlerWrapper = (param, resultHandler, errorHandler) => {
        Object.assign(session_data, param.data);
        let resultHandlerWrapper = (result) => {
            if (result.password) {
                let password = result.password;
                delete result.password;
                let requires = param.require || [];
                if (requires.indexOf("verify_password") !== -1) {
                    let clientEphemeral = privateData.clientEphemeral;
                    let user_id = session_data.user_id || "";
                    let salt = session_data.salt || "";
                    let srp_B = session_data.srp_B || "";
                    let privateKey = (0, client_1.derivePrivateKey)(salt, user_id, password);
                    let verifier = (0, client_1.deriveVerifier)(privateKey);
                    log("a:");
                    log(clientEphemeral.secret);
                    log("verifier:");
                    log(verifier);
                    let clientSession = (0, client_1.deriveSession)(clientEphemeral.secret, srp_B, salt, user_id, privateKey);
                    result.client_M = clientSession.proof;
                    privateData.clientSession = clientSession;
                }
                else if (requires.indexOf("password_secret") !== -1) {
                    let user_id = session_data.user_id || "";
                    let salt = session_data.salt || "";
                    let privateKey = (0, client_1.derivePrivateKey)(salt, user_id, password);
                    let verifier = (0, client_1.deriveVerifier)(privateKey);
                    log("verifier:");
                    log(verifier);
                    let encrypt = new jsencrypt_1.JSEncrypt({});
                    if (session_data.key) {
                        encrypt.setPublicKey(session_data.key);
                        result.key_ver = session_data.key_ver;
                    }
                    else {
                        encrypt.setPublicKey(bu_account_config_1.BUAccountConfig.RSAPublicKey);
                    }
                    let encrypted = "";
                    if (verifier.length > 501) {
                        encrypted = encrypt.encrypt(verifier.substr(0, 501));
                        verifier = verifier.substr(501, verifier.length - 501);
                        while (verifier.length > 0) {
                            encrypted += ("|||" + encrypt.encrypt(verifier.substr(0, 501)));
                            verifier = verifier.substr(501, verifier.length - 501);
                        }
                    }
                    else {
                        encrypted = encrypt.encrypt(verifier);
                    }
                    result.password_secret = encrypted;
                }
            }
            resultHandler(result);
        };
        if (sessionHandler) {
            if (session_data.lang && param.data) {
                param.data["lang"] = session_data.lang;
            }
            sessionHandler(param, resultHandlerWrapper, errorHandler);
        }
    };
    let handleFetch = (param) => {
        if (session_data.session_id) {
            param.session_id = session_data.session_id;
        }
        const config = {
            headers: Object.assign({ "Content-Type": "application/json" }, (accessToken ? { Authorization: `Bearer ${accessToken}` } : {})),
            params: Object.assign({ ts: Date.now() }, (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().commonParam),
        };
        return axios_1.default
            .post(url, param, config)
            .catch((error) => {
            if (error.message && error.message.startsWith("timeout of ")) {
                log(`timeout try again: ${url}`);
                return axios_1.default.post(url, param, config);
            }
            else {
                throw error;
            }
        })
            .then((response) => {
            return response.data;
        })
            .catch((error) => {
            const response = error.response;
            if (!response) {
                if (error.message && error.message.startsWith("timeout of ")) {
                    return { code: -99998, message: error.message };
                }
                return error.message;
            }
            if (response.status === 403) {
                return { code: -99999, message: "too many requests" };
            }
            else if (response.status < 403) {
                if (response.data) {
                    return response.data;
                }
            }
            return {
                code: -99900,
                message: `status:${response.status} statusText:${response.statusText} message:${error.message}`,
            };
        })
            .then((responseData) => {
            if (typeof responseData === "string") {
                throw { code: -99900, message: `unexpected response: ${responseData}` };
            }
            return handleResult(responseData);
        });
    };
    let onActionFlow = (sessionResult) => {
        return new Promise((resolve, reject) => {
            let completeHanler = (result) => resolve(result);
            let errorHandler = (error) => reject(error);
            sessionHandlerWrapper(sessionResult, completeHanler, errorHandler);
        }).then((param) => {
            log(JSON.stringify(param));
            return handleFetch(param);
        });
    };
    let handleResult = (responseData) => {
        if (responseData.code !== 0) {
            ///> Session结束了本次验证flow就结束了
            const isSessionEnd = responseData.message && responseData.message.startsWith("session not existed");
            const retryCodes = [
                "-4209",
                "-4210",
                "-5203",
                "-109903",
                "-4212",
                "-102000",
                "-100501",
                "-100508",
                "-100511",
                "-101012",
                "-101033",
                "-100011",
                "-101601",
            ];
            const isRetryCode = retryCodes.includes(responseData.code.toString());
            if (session_data["response_cache"] && !isSessionEnd && isRetryCode) {
                session_data["response_cache"].verify_failed = responseData;
                return onActionFlow(session_data["response_cache"]);
            }
            else {
                throw responseData;
            }
        }
        else {
            let sessionResult = responseData.data;
            if (sessionResult.session_id) {
                if (session_data.session_id) {
                    if (session_data.session_id !== sessionResult.session_id) {
                        throw new Error("seesion_id not matched");
                    }
                }
                else {
                    session_data.session_id = sessionResult.session_id;
                }
            }
            if (sessionResult.done) {
                return sessionResult.data;
            }
            else {
                if (path.endsWith("register_v2") ||
                    path.endsWith("login_v3") ||
                    path.endsWith("bind_v2") ||
                    path.endsWith("request_reset_otp_v2") ||
                    path.endsWith("forget_password_v2") ||
                    path.endsWith("request_reset_otp_v2") ||
                    path.endsWith("account_bind") ||
                    path.endsWith("reset_security_account") ||
                    path.endsWith("bind_biometric_keys") ||
                    path.endsWith("third_account/auth") ||
                    path.endsWith("third_account/bind") ||
                    path.endsWith("/bind_passkey") ||
                    path.endsWith("/unbind_passkey")) {
                    session_data["response_cache"] = sessionResult;
                    session_data["response_cache"].verify_failed = undefined;
                }
                return onActionFlow(sessionResult);
            }
        }
    };
    let requestInitParam = initParam || {};
    requestInitParam.version = "2.0";
    if (requestInitParam.lang) {
        session_data.lang = requestInitParam.lang;
    }
    return handleFetch(requestInitParam);
}
exports.apiRequest = apiRequest;
